export function useCommunityContact(){
 const state=reactive({owner:0,ready:false,dismissed:true,open:false,status:''});
 let epoch=0;
 const key=(owner:number)=>'uogorod.community-contact.dismissed.v1:'+owner;
 const cached=(owner:number)=>{try{return localStorage.getItem(key(owner))==='1'}catch{return false}};
 const remember=(owner:number)=>{try{localStorage.setItem(key(owner),'1')}catch{/* Account preference remains authoritative. */}};
 async function persist(owner:number,ticket:number){
  try{await $fetch('/api/profiles/community-contact',{method:'POST',body:{dismissed:true}});if(ticket===epoch&&owner===state.owner)state.status='Блок скрыт. Ссылки остаются внизу сайта.';}
  catch{if(ticket===epoch&&owner===state.owner)state.status='Блок скрыт на этом устройстве. Настройка аккаунта сохранится после восстановления связи.';}
 }
 async function load(owner:number){
  const ticket=++epoch;Object.assign(state,{owner,ready:false,dismissed:true,open:false,status:''});
  if(!owner)return;
  const local=cached(owner);
  try{
   const result=await $fetch<{dismissed:boolean}>('/api/profiles/community-contact');
   if(ticket!==epoch||owner!==state.owner)return;
   state.dismissed=local||result.dismissed;state.ready=true;
   if(result.dismissed)remember(owner);
   else if(local)await persist(owner,ticket);
  }catch{/* Do not flash an invitation when the saved preference cannot be checked. */}
 }
 function dismiss(){const owner=state.owner;if(!owner)return;remember(owner);state.dismissed=true;state.open=false;void persist(owner,epoch);}
 function retry(){if(state.owner&&cached(state.owner))void persist(state.owner,epoch);else if(state.owner)void load(state.owner);}
 return {state,load,dismiss,retry};
}
